import { ReactComponent as ChevronUpSvg } from '../../assets/icons/chevron-up.svg';

export const ChevronUpIcon: SvgIcon = (props) => {
    return <ChevronUpSvg {...props} />;
};
